import { render, staticRenderFns } from "./FileUploadSorter.vue?vue&type=template&id=77942bf0"
import script from "./FileUploadSorter.vue?vue&type=script&lang=js"
export * from "./FileUploadSorter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports